import { AuthConstant } from '../actions/constants/AuthConstant';
import { ORG_HQ } from '../config/appConstants';
import { safeGetItem, safeRemoveItem } from '../lib/safeStorage';

// BUG-241 회귀 방지 — 'user' 값이 존재하지만 JSON.parse 가 throw 하면(손상된 JSON) stale
// 인증 키를 전부 정리한다. 무음 차단 금지(CLAUDE.md silent-drop 규칙).
// 정리 기준은 JSON.parse 의 throw 여부뿐이다 — 파싱은 됐지만 비객체(0/false/null/문자열)인
// 값은 정리 대상이 아니다(user = null 로만 처리).
const clearCorruptedUserKeys = () => {
	console.warn('[AuthReducer] corrupted "user" value in storage — clearing auth keys', {
		handler: 'AuthReducer.moduleInit',
		reason: 'JSON.parse("user") threw',
	});
	safeRemoveItem('user');
	safeRemoveItem('clist');
	safeRemoveItem('userToken');
	safeRemoveItem('rtUser');
	safeRemoveItem('rtToken');
};

let user, userToken;
const rawUser = safeGetItem('user');
if (rawUser === null || rawUser === undefined) {
	user = null;
} else {
	try {
		const parsed = JSON.parse(rawUser);
		user = (parsed && typeof parsed === 'object') ? parsed : null;
	} catch (e) {
		user = null;
		clearCorruptedUserKeys();
	}
}
const clist = safeGetItem('clist');
userToken = safeGetItem('userToken');

if (user && clist) {
	if (!user.adminid) {
		// const user = JSON.parse(localStorage.getItem('user'));
		safeRemoveItem('user');
		safeRemoveItem('userToken');
		user = {};
		userToken = "";
	}

	if (user?.rguardSettingDarkMode) {
		document.body.classList.add('dark-mode');
	}

	if (!user?.settings) {
		user.settings = {};		
	}

	if (!user?.adminheaders) {
		user.adminheaders = {};
	}
	
	if (!Array.isArray(user?.filters)) {
		user.filters = [];
	}
}
const initialState = (user && clist)
	? {
		loggingIn: true,
		user,
		isAdmin: false,
		isUpdateRes: false,
		userToken : userToken,
		isLoading : false,
		su : user?.companyInfo?.org == ORG_HQ,
	  }
	: { 
		isLoading : false,
		loggingIn: false,
		su : false
	};

export const AuthReducer = (state = initialState, action) => {
	switch (action.type) {
		case AuthConstant.LOGIN_REQUEST:
			return { user: action.user };
		case AuthConstant.LOGIN_SUCCESS:
			if(action.user.rguardSettingDarkMode == true)
				document.body.classList.add('dark-mode');
			return { loggingIn: true, user: action.user, isAdmin: false, su : action.user?.companyInfo?.org == ORG_HQ, userToken : action.userToken};
		case AuthConstant.ADMINLOGIN_SUCCESS:			
			return { loggingIn: true, user: action.user, isAdmin: true, su : action.user?.companyInfo?.org == ORG_HQ, userToken : action.userToken };
		case AuthConstant.TEST:
			return { ...state };
		case AuthConstant.CLEAR_UPDATERES:
			return { ...state, isUpdateRes: false };
		case AuthConstant.UPDATE_SUCCESS:
			if(action.user.rguardSettingDarkMode == true)
				document.body.classList.add('dark-mode');
			return { ...state, user: action.user, isUpdateRes: true };
		case AuthConstant.UPDATE_ADMINSETTING:
			return { ...state, user: action.user };
		case AuthConstant.UPDATE_ADMINFILTERS:
			return { ...state, user: action.user };
		case AuthConstant.LOGIN_FAILURE:
			return { loggingIn: false };
		case AuthConstant.LOGOUT:
			return { user : null,  loggingIn: false };
        case AuthConstant.LOADING:
            return {...state, isLoading : true}
        case AuthConstant.LOADED:
            return {...state, isLoading : false}
		default:
			return state;
	}
};
